import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-energy-tab-navigation',
  templateUrl: './energy-tab-navigation.component.html',
  styleUrls: ['./energy-tab-navigation.component.scss']
})
export class EnergyTabNavigationComponent implements OnInit {
  activeTab: string = 'energy';

  public hasBidi: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }

  onTabChange(tabId: string): void {
    console.log(`Switched to tab: ${tabId}`);
    this.activeTab = tabId;
  }
}
